import React, { useState } from 'react';
import { HEALTH_STATUS } from '../../services/apiHealth';
import './ApiHealthStatus.scss';

const STATUS_CONFIG = {
    [HEALTH_STATUS.CHECKING]: { icon: 'fa-circle-notch fa-spin', tone: 'checking', label: 'Checking service status' },
    [HEALTH_STATUS.ONLINE]: { icon: 'fa-circle-check', tone: 'online', label: 'Service online' },
    [HEALTH_STATUS.DEGRADED]: { icon: 'fa-triangle-exclamation', tone: 'degraded', label: 'Degraded service' },
    [HEALTH_STATUS.CORS]: { icon: 'fa-shield-halved', tone: 'down', label: 'Blocked by server configuration' },
    [HEALTH_STATUS.OFFLINE]: { icon: 'fa-circle-xmark', tone: 'down', label: 'Service unavailable' },
};

const DetailRow = ({ label, value }) => (
    <div className="detail-row">
        <span className="detail-label">{label}</span>
        <span className="detail-value">{value}</span>
    </div>
);

const ApiHealthStatus = ({ health, isChecking, onRecheck }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const config = STATUS_CONFIG[health.status] || STATUS_CONFIG[HEALTH_STATUS.CHECKING];
    const isHealthy = health.status === HEALTH_STATUS.ONLINE;
    const checkedAt = health.checkedAt ? new Date(health.checkedAt).toLocaleTimeString() : null;

    return (
        <div className={`api-health ${config.tone}`}>
            <button type="button" className="api-health-summary" onClick={() => setIsExpanded(prev => !prev)}>
                <span className={`fas ${config.icon} status-icon`} />
                <span className="status-label">{config.label}</span>
                {isHealthy && health.latency != null && <span className="status-meta">{health.latency} ms</span>}
                <span className={`fas fa-chevron-${isExpanded ? 'up' : 'down'} chevron`} />
            </button>

            {/* A problem is always spelled out; the healthy message stays behind the toggle. */}
            {!isHealthy && health.message && <div className="api-health-message">{health.message}</div>}

            {isExpanded && (
                <div className="api-health-details">
                    {isHealthy && <DetailRow label="Status" value={health.message} />}
                    <DetailRow label="Endpoint" value={health.apiUrl || 'Not configured'} />
                    {health.version && <DetailRow label="API version" value={`v${health.version}`} />}
                    {health.uptime && <DetailRow label="Uptime" value={health.uptime} />}
                    {health.internetConnectivity != null && (
                        <DetailRow
                            label="Server connectivity"
                            value={health.internetConnectivity ? 'Online' : 'Offline'}
                        />
                    )}
                    {health.latency != null && <DetailRow label="Response time" value={`${health.latency} ms`} />}
                    {checkedAt && <DetailRow label="Last checked" value={checkedAt} />}

                    <button type="button" className="api-health-retry" onClick={onRecheck} disabled={isChecking}>
                        <span className={`fas fa-rotate-right me-2 ${isChecking ? 'fa-spin' : ''}`} />
                        {isChecking ? 'Checking...' : 'Check again'}
                    </button>
                </div>
            )}
        </div>
    );
};

export default ApiHealthStatus;
